import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 34 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 34.10: requires both 34.11 AND 34.12 zugmeldestelle.name content
 * - Returns true if ANY field is empty (warns if either is missing)
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl34EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag3410 = findAuftrag(befehl, '34.10')
  if (auftrag3410) {
    const has3411 = hasFieldContent(auftrag3410, '34.11', 'kmh')
    const has3412art = hasFieldContent(
      auftrag3410,
      '34.12',
      'zugmeldestelle.art'
    )
    const has3413art = hasFieldContent(
      auftrag3410,
      '34.13',
      'zugmeldestelle.art'
    )
    const has3412name = hasFieldContent(
      auftrag3410,
      '34.12',
      'zugmeldestelle.name'
    )
    const has3413name = hasFieldContent(
      auftrag3410,
      '34.13',
      'zugmeldestelle.name'
    )

    // Return true if ANY field is empty (either 34.11 OR 34.12 (art/name) OR 34.13 (art/name) is empty)
    return (
      !has3411 || !has3412art || !has3412name || !has3413art || !has3413name
    )
  }

  return false
}
